<template>
  <div class="indicators">
    <template v-for="(indicator, index) in indicators" :key="index">
      <div class="indicator">
        <component :is="indicator.icon" class="icon" />
        <div>
          <div class="text">
            {{ indicator.label }}
          </div>
          <div class="data">
            <slot name="data" :indicator="indicator">
              {{ indicator.value }}
            </slot>
          </div>
        </div>
      </div>
    </template>
  </div>
  <div v-if="hasDisplayMore" class="cta">
    <uikit-button type="link" @click="handleDisplayMore">
      <template #icon>
        <uikit-chevron-icon :type="displayMore ? 'up' : 'down'" />
      </template>
      {{ displayMore ? 'Voir moins' : 'Voir plus' }}
    </uikit-button>
  </div>
</template>

<script setup>
import { UikitChevronIcon, UikitButton } from '@hz/ui-kit'

const props = defineProps({
  indicators: {
    type: Array,
    required: true,
  },
})

const LIMIT = 6

const displayMore = ref(false)

const hasDisplayMore = computed(() => props.indicators.length > LIMIT)

const indicators = computed(() => {
  if (displayMore.value) {
    return props.indicators
  }

  return props.indicators.slice(0, LIMIT)
})

const handleDisplayMore = () => {
  displayMore.value = !displayMore.value
}
</script>

<style lang="less" scoped>
.indicators {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 32px 0;

  .indicator {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    min-width: 225px;
    width: 33%;

    .icon {
      height: 40px;
      width: 40px;
      color: var(--ds-color-primary-100);
      padding: 8px;
      background: var(--ds-color-primary-25);
      border-radius: 4px;
    }

    .text {
      font-size: 14px;
      color: var(--ds-color-gray-50);
      font-weight: 500;
    }

    .data {
      color: var(--ds-color-gray-50);
      font-weight: var(--ds-weight-semi-bold);
    }
  }
}

.cta {
  margin-top: 12px;

  :deep(.uikit-chevron-icon-down),
  :deep(.uikit-chevron-icon-up) {
    height: 16px;
    width: 16px;
  }

  :deep(.uikit-chevron-icon-down) {
    margin-bottom: -3px;
  }

  :deep(.uikit-chevron-icon-up) {
    margin-top: 1px;
  }
}

@media @bp-lg {
  .indicators {
    gap: 24px 0;
  }
  .cta {
    margin-top: 24px;
  }
}
</style>
